import $ from 'jquery';

const BASE_SELECTOR: string = '[data-form-ajax]';
const SAVE_BUTTON_SELECTOR: string = '[data-save-button]';

export class FormAjaxUI {
    constructor(private $base: JQuery<HTMLElement>) {
    }
    
    public onSubmit(callback: () => {}) {
        $(SAVE_BUTTON_SELECTOR).on('click', () => callback());
    }
    
    public disableSubmitButton() {
        $(SAVE_BUTTON_SELECTOR).attr('disabled', 'disabled').addClass('loading');
    }
    
    public enableSubmitButton() {
        $(SAVE_BUTTON_SELECTOR).removeAttr('disabled').removeClass('loading');
    }
    
    public getFormName(): string {
        return this.$base.attr('name');
    }
    
    public getFormAction():string {
        return this.$base.attr('action');
    }
}

export function createFormAjaxInstances() {
    const instances: FormAjaxUI[] = [];
    $(BASE_SELECTOR).each((i, el) => {
        instances.push(new FormAjaxUI($(el)));
    });
    
    return instances;
}
